









// @ts-nocheck
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { DataStore } from 'aws-amplify'
import { Checklist, District } from '../models/index'
import { query as tenant } from '@/store/tenant'

@Component<ChecklistPicker>({
  components: {
  },
  apollo: {
    tenant,
  },
  data: function () {
    return {}
  },
})
export default class ChecklistPicker extends Vue {

  checklists = []
  checklistsSubscription = null
  @Prop({ required: true })
  selections!: []
  

  @Watch('tenant')
  async recreate() {
    this.subscribeToChecklists();
  }

  created() {
    this.subscribeToChecklists();
  }

  async subscribeToChecklists() {
    if (!this.tenant) return;
    this.checklistsSubscription?.unsubscribe()
    const districts = await DataStore.query(District, p => p.tenant.eq(this.tenant.id))
    this.checklistsSubscription = DataStore.observeQuery(
      Checklist,
      p => p.tenant.eq(this.tenant.id)
    ).subscribe(async ({ items }) => {
      this.checklists = (await Promise.all([...items].map(async (e) => {
        const [district] = await DataStore.query(District, d => d.id.eq(e.districtID));
        if (!district) return null
        var text = e.title.de;
        if(districts.length > 1) text = `${text} (${district?.name?.de})`
        return { text, value: e.id }
      }))).filter(e => e != null).sort((a, b) => a.text.localeCompare(b.text))
    })
  }

  created() {
    this.subscribeToChecklists()
  }
  destroyed() {
    this.checklistsSubscription.unsubscribe()
  }

  selectAll() {
    this.$nextTick(() => { 
      const checkboxes = this.$refs.selector.$children[2].$children[0].$children[0].$el.getElementsByClassName('v-simple-checkbox');
      [...checkboxes].map((e) => e.click());             
    })
  }

  @Watch('selections', { immediate: true })
  emitSelections() {
    this.$emit('update:selections', this.selections);
  }

  
}
